module.exports = __webpack_public_path__ + "media/remove_text.3449b2e7.mp4";